import React from 'react';

class StateSmileCenter extends React.Component {


  render() {
    return <li className="smilecenter list-item" onClick={()=> this.props.clickHandler(this.props.state)}>{this.props.state}</li>;
  }

}

export default StateSmileCenter;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/StateSmileCenter/StateSmileCenter.js